import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import Layout from "../layout/Layout";
import Analysis from "../screen/Analysis/Analysis";
import Error from "../screen/Error/Error";

//Pages :*
import Home from "../screen/Home/Home";
import Login from "../screen/Login/Login";
import TwoFactorPage from "../screen/Login/TwoFactor";
import CreateSurvey from "../screen/Survey/CreateSurvey/CreateSurvey";
import EditSurvey from "../screen/Survey/EditSurvey/EditSurvey";
import UserSurvey from "../screen/Survey/UserSurvey/UserSurvey";

export default function Router() {
  return (
    <Switch>
      <Route exact path="/">
        <Suspense fallback={"Yükleniyor"}>
          <Login />
        </Suspense>
      </Route>
      <Route exact path="/twofactor">
        <Suspense fallback={"Yükleniyor"}>
          <TwoFactorPage />
        </Suspense>
      </Route>
      <Route path="/survey/:id/:lang/:scale">
        <Suspense fallback={"Yükleniyor"}>
          <UserSurvey />
        </Suspense>
      </Route>
      <Route path="/survey/:id/:lang">
        <Suspense fallback={"Yükleniyor"}>
          <UserSurvey />
        </Suspense>
      </Route>
      <Route path="/survey/:id">
        <Suspense fallback={"Yükleniyor"}>
          <UserSurvey />
        </Suspense>
      </Route>
      <Route path="/home">
        <Suspense fallback={"Yükleniyor"}>
          <Home />
        </Suspense>
      </Route>
      <Route path="/createsurvey">
        <Suspense fallback={"Yükleniyor"}>
          <CreateSurvey />
        </Suspense>
      </Route>
      <Route path="/editsurvey/:id">
        <Suspense fallback={"Yükleniyor"}>
          <EditSurvey />
        </Suspense>
      </Route>
      <Route path="/analysis/:id">
        <Suspense fallback={"Yükleniyor"}>
          <Analysis />
        </Suspense>
      </Route>

      <Route path="*">
        <Error
          error={404}
          code={404}
          historylink={"/"}
          text={"Giriş Sayfasın Geri Dön"}
        />
      </Route>
    </Switch>
  );
}
